/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextBulletChecklistIcon16Light } from './TextBulletChecklistIcon16Light';
import { TextBulletChecklistIcon16Regular } from './TextBulletChecklistIcon16Regular';
import { TextBulletChecklistIcon16Solid } from './TextBulletChecklistIcon16Solid';
import { TextBulletChecklistIcon20Light } from './TextBulletChecklistIcon20Light';
import { TextBulletChecklistIcon20Regular } from './TextBulletChecklistIcon20Regular';
import { TextBulletChecklistIcon20Solid } from './TextBulletChecklistIcon20Solid';
import { TextBulletChecklistIcon24Regular } from './TextBulletChecklistIcon24Regular';
import { TextBulletChecklistIcon24Solid } from './TextBulletChecklistIcon24Solid';
import { TextBulletChecklistIcon32Regular } from './TextBulletChecklistIcon32Regular';
import { TextBulletChecklistIcon64Regular } from './TextBulletChecklistIcon64Regular';
var sizes = {
    16: {
        light: TextBulletChecklistIcon16Light,
        regular: TextBulletChecklistIcon16Regular,
        solid: TextBulletChecklistIcon16Solid,
    },
    20: {
        light: TextBulletChecklistIcon20Light,
        regular: TextBulletChecklistIcon20Regular,
        solid: TextBulletChecklistIcon20Solid,
    },
    24: {
        regular: TextBulletChecklistIcon24Regular,
        solid: TextBulletChecklistIcon24Solid,
    },
    32: {
        regular: TextBulletChecklistIcon32Regular,
    },
    64: {
        regular: TextBulletChecklistIcon64Regular,
    },
};
export var TextBulletChecklistIcon = forwardRef('TextBulletChecklistIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
